import { get } from "../../utils";
import {
  ERROR_TECNICO,
  INDIVIDUO_NEGATIVO,
  RECHAZADO_OTROS,
  ERROR_NOSIS,
  RECHAZADO,
  ERROR_CONFIRMACION_RENAPER,
  CLIENTE_NO_CENSADO,
  ERROR_SOLICITUD,
  ERROR_INICIO_VERIDAS,
  ERROR_CONEXION,
  ERROR_DNI,
  ERROR_HABILITA_PERMISOS,
  ERROR_SERVICIO_VERIDAS,
  ERROR_SELFIE,
  ERROR_SERVICIO_ASO,
  ERROR_SERVICIO_RENAPER,
  ERROR_SERVIDOR,
  ERROR_REINTENTOS_BIOMETRIA,
  ERROR_VERIDAS_RESULT,
  ERROR_VERIDAS_CA,
  ERROR_TOKEN_EXPIRED,
  ERROR_REGISTRAR_DOMICILIO,
  YA_CONTRATO,
  DATOS_INCORRECTOS,
  ERROR_CELULAR,
  ERROR_CONYUGE,
  ERROR_DOMICILIO,
  ERROR_EMAIL
} from "./step-constants";

const alertError = require("../../assets/img/1x/alert_error.svg");
const errorTecnico = require("../../assets/img/1x/error_tecnico.svg");
const errorConexion = require("../../assets/img/1x/ilus-tc.svg");

const errores = {
  [ERROR_CONEXION]: {
    title:
      "Hay un problema con la conexión que estamos tratando de solucionar. ",
    subtitle: "Podés volver a intentar más tarde.",
    icon: errorConexion
  },
  [ERROR_TECNICO]: {
    title:
      "En este momento no podemos procesar la solicitud por inconvenientes técnicos",
    subtitle: "Por favor, volvé a intentarlo en unos minutos.",
    icon: errorTecnico,
    analyticsModule: "mensaje 1"
  },
  [INDIVIDUO_NEGATIVO]: {
    title: "Ya tenés una solicitud en curso",
    subtitle:
      "En breve, un representante de BBVA se pondrá en contacto contigo.",
    icon: alertError,
    analyticsModule: "mensaje 2"
  },
  [RECHAZADO]: {
    title: "En este momento no tenemos ningún producto para ofrecerte",
    subtitle:
      "Podés acercarte a cualquiera de nuestras sucursales para recibir información detallada.",
    icon: alertError,
    analyticsModule: "mensaje 3"
  },
  [ERROR_NOSIS]: {
    title: "Alguno de los datos que ingresaste no son correctos",
    subtitle:
      "Desde el botón Volver, podrás regresar a la pantalla anterior para editar los datos ingresados.",
    icon: alertError
  },
  [RECHAZADO_OTROS]: {
    title: "Alguno de los datos que ingresaste no son correctos",
    subtitle:
      "Desde el botón Volver, podrás regresar a la pantalla anterior para editar los datos ingresados.",
    icon: alertError
  },
  [CLIENTE_NO_CENSADO]: {
    title:
      "Por no haber participado del Censo Nacional Económico Obligatorio, no podrás realizar esta operación",
    subtitle:
      "<strong>Para poder continuar debés completar el censo y volver a intentarlo a las 24hs.</strong><br /><br /><a class='generic-link' href='https://www.bbva.com.ar/economia-para-tu-dia-a-dia/novedades/que-es-el-censo-nacional-economico.html'>Te contamos cómo hacerlo</a>",
    icon: alertError
  },
  [ERROR_CONFIRMACION_RENAPER]: {
    title: "No pudimos verificar tu información",
    subtitle:
      "Desde el botón Volver, podrás regresar a la pantalla anterior para comprobar que tu información sea correcta.",
    icon: alertError
  },
  [ERROR_SOLICITUD]: {
    title: "La solicitud no se pudo completar",
    subtitle:
      "Ingresá a Banca Online y conocé los productos a los que podés acceder.",
    icon: alertError,
    analyticsModule: "error solicitud"
  },
  [ERROR_INICIO_VERIDAS]: {
    text:
      '<p tabindex="0">No pudimos detectar una cámara en tu dispositivo.<br>Por favor, intentá desde otro dispositivo .</p>'
  },
  [ERROR_HABILITA_PERMISOS]: {
    text:
      '<p class="titulo">Te pedimos que habilites los permisos de tu navegador<br /><br /> Necesitamos acceder a la cámara de tu dispositivo.</p>'
  },
  [ERROR_DNI]: {
    text:
      '<p class="titulo">Intentá nuevamente. <br /> Comprobá que tus fotos estén bien enfocadas.</p>'
  },
  [ERROR_SELFIE]: {
    text:
      '<p class="titulo">Intentá nuevamente. <br /> Comprobá que tus fotos estén bien enfocadas.</p>'
  },
  [ERROR_SERVICIO_VERIDAS]: {
    text: '<p tabindex="0">Tuvimos un problema volvé a intentar más tarde</p>'
  },
  [ERROR_SERVICIO_ASO]: {
    text: '<p tabindex="0">Tuvimos un problema volvé a intentar más tarde</p>'
  },
  [ERROR_SERVICIO_RENAPER]: {
    text: '<p tabindex="0">Tuvimos un problema volvé a intentar más tarde</p>'
  },
  [ERROR_SERVIDOR]: {
    text:
      '<p class="mensaje-error" tabindex="0">Por favor volvé a intentar más tarde</p>'
  },
  [ERROR_VERIDAS_RESULT]: {
    text:
      '<p tabindex="0">¡Probá nuevamente!<br>Comprobá que tus fotos estén bien enfocadas</p>'
  },
  [ERROR_REINTENTOS_BIOMETRIA]: {
    text:
      '<p class="titulo">Mostrale tu DNI a la persona del correo que te entregue tu tarjeta de crédito. <br/><br/> Ahora continuá con tu solicitud.</p>'
  },
  [ERROR_VERIDAS_CA]: {
    text:
      '<p class="titulo">Podés acercarte a cualquiera de nuestras sucursales para recibir información detallada.</p>'
  },
  [ERROR_TOKEN_EXPIRED]: {
    text:
      '<p class="titulo">No fue posible capturar la imágen, te pedimos por favor que lo vuelvas a intentar.</p>'
  },
  [ERROR_REGISTRAR_DOMICILIO]: {
    title: "Tenemos un problema para registrar tu dirección.",
    subtitle:
      '<strong> Si ya sos cliente</strong>, registrá tu domicilio actual en Banca Online.<p class="titulo">En tu perfil con tu nombre, ingresá a Datos personales > Domicilios (al final) > Nuevo domicilio. Elegí el tipo Residencia y cargá tu dirección. <br><p class="titulo">Una vez que tu dirección actual esté registrada, regresa para finalizar la contratación.  <p/> <p class="titulo"><strong>Si aún no sos cliente, </strong>por favor, acercate a una sucursal para abrir tu cuenta.',
    icon: errorTecnico,
    buttonName: "Ir a Banca Online",
    buttonUrl: "https://www.bbva.com.ar/fnetcore/loginClementeApp.html"
  },
  [YA_CONTRATO]: {
    title: "Ya procesamos la solicitud de tu Cuenta.",
    subtitle:
      "Ingresá a Banca Online y creá tu usuario y clave digital para comenzar a operar.",
    icon: errorTecnico,
    buttonName: "Ir a Banca Online",
    buttonUrl: "https://www.bbva.com.ar/fnetcore/loginClementeApp.html"
  },
  [DATOS_INCORRECTOS]: {
    title: "¡Probá nuevamente!",
    subtitle:
      "Comprobá que tu información este bien<br> para continuar con el proceso.",
    icon: errorTecnico
  },
  [ERROR_CELULAR]: {
    title: "No pudimos validar tu <strong>celular</strong>",
    subtitle: "Revisá que sea correcto y volvé a intentarlo",
    icon: errorTecnico
  },
  [ERROR_DOMICILIO]: {
    title: "No pudimos validar tu <strong>domicilio</strong>",
    subtitle: "Revisá que sea correcto y volvé a intentarlo",
    icon: errorTecnico
  },
  [ERROR_CONYUGE]: {
    title:
      "No pudimos validar el <strong>número de documento de tu conyuge</strong>",
    subtitle: "Revisá que sea correcto y volvé a intentarlo",
    icon: errorTecnico
  },
  [ERROR_EMAIL]: {
    title:
      "No pudimos validar alguno de tus <strong>correos electrónicos</strong>",
    subtitle: "Revisá que sean correctos y volvé a intentarlo",
    icon: errorTecnico
  }
};
const erroresContratacion = {
  CLE0534: {
    mensaje: "error-celular",
    errorType: "error datos prefijo erroneo"
  },
  CLE0535: {
    mensaje: "error-celular",
    errorType: "error numero de telefono"
  },
  CLE0536: {
    mensaje: "error-celular",
    errorType: "error caracteristica telefono"
  },
  CLE0537: {
    mensaje: "error-celular",
    errorType: "error telefono cero"
  },
  CLE0538: {
    mensaje: "error-celular",
    errorType: "error telefono base negativa"
  },
  CLE1296: {
    mensaje: "error-celular",
    errorType: "error telefono fijo como celular"
  },
  CLE0886: {
    mensaje: "error-domicilio",
    errorType: "error puerta domicilio"
  },
  CLE0361: {
    mensaje: "error-domicilio",
    errorType: "error caracteres calle"
  },
  CLE0061: {
    mensaje: "error-domicilio",
    errorType: "error domicilio y codigo postal"
  },
  JCLE530: {
    mensaje: "error-conyuge",
    errorType: "error documento conyuge"
  },
  JCLE405: {
    mensaje: "error-email",
    errorType: "error correo electronico"
  }
};

export const getParamMensajeContratacion = (errores, campo = "mensaje") => {
  // Obtengo la lista de errores que vienen en la confirmación y filtro
  // por código que viene en paréntesis
  const listaErrores = errores.map(error => {
    const _match = error.match(/\(([^)]{0,50})\)/);
    return get(_match, "[1]", error);
  });
  // Filtro por map obteniendo el primer error y por defecto mando a mensaje-4
  return get(
    erroresContratacion,
    `${get(listaErrores, "[0]", null)}.${campo}`,
    campo === "mensaje" ? "mensaje-4" : ERROR_CONEXION
  );
};

const ERROR_CODES_CONTINUA_SUCURSAL = ["PAE0754"];

export { ERROR_CODES_CONTINUA_SUCURSAL };
export default errores;
